<!-- Do not change this file. -->

<template>
  <div class="navbar navbar-dark bg-dark">
    <div class="container-fluid">
      <div class="d-flex justify-content-between">
        <div
          class="navbar-brand d-flex py-0 py-sm-auto align-items-center"
          role="banner"
        >
          <img
            src="@/assets/logo-dark.svg"
            alt="Oregon State University Logo"
            height="30"
            class="d-none d-sm-inline-flex align-top me-3 pe-3 border-end"
          />
          <img
            src="@/assets/logo-dark.svg"
            alt="Oregon State University Logo"
            height="40"
            class="d-inline-flex d-sm-none align-top me-3 pe-3 border-end"
          />
          <div class="d-none d-sm-block title me-3 fw-bold">{{ course }}</div>
          <div class="subtitle d-none d-sm-block">{{ title }}</div>
          <div class="d-flex flex-column d-sm-none align-items-start">
            <div class="title me-3 fw-bold fs-6">{{ course }}</div>
            <div class="subtitle fs-6">{{ shortTitle }}</div>
          </div>
        </div>
      </div>
      <div>
        <div class="text-uppercase" v-if="env">
          <span class="badge bg-danger d-block text-uppercase"
            >{{ env }} build</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Do not change this file. */

import config from "@/data/config";

export default {
  name: "TheHeader",
  data() {
    return {
      course: config.meta.course,
      title: config.meta.title,
      shortTitle: config.meta.shortTitle
    };
  },
  computed: {
    env() {
      let showLabel = import.meta.env.VITE_SHOW_ENV_LABEL;

      if (showLabel === "false" || showLabel === false) {
        return false;
      }

      const host = window.location.host;
      const subdomain = host.split(".")[0];

      switch (subdomain) {
        case "testing":
          return "test";
        case "demo":
          return "demo";
        case "web":
          return false;
        default:
          return "development";
      }
    }
  }
};
</script>